<template>
  <div class="redirect-cont">
    <h1>Redirection</h1>
    <p v-if="errorMessage">{{ errorMessage }}</p>
    <p v-else>Vous allez être redirigé vers la page de connexion.</p>
  </div>
</template>

<script>
import { ERequestType, fetchGetHelper } from '../tools/fetch';

export default {
  name: 'Redirect',
  data() {
    return {
      errorMessage: null
    }
  },
  async mounted() {
    await this.getRedirectLink()
  },
  methods: {
    async getRedirectLink() {
      try {
        const shortcode = this.$route.params.shortcode
        const res = await fetchGetHelper(ERequestType.REDIRECT.GET, `shortCode=${shortcode}`)

        if (res.data) {
          window.location.href = res.data
        } else {
          this.errorMessage = 'Le lien est invalide ou a expiré.'
          console.error('Invalid redirection data:', res)
        }
      } catch (err) {
        this.errorMessage = 'Une erreur est survenue lors de la redirection.'
        console.error('Error fetching redirect link:', err)
        this.$store.dispatch('logout')
      }
    }
  }
}
</script>

<style lang="scss">
.redirect-cont {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: calc(100% - 40px);
  padding: 0 20px;

  h1 {
    text-align: center;
  }

  p {
    text-align: center;
  }
}
</style>
